__webpack_require__.p = "https://wp.stolaf.edu/wp-content/plugins/core/assets/theme/js/wp-dist/";